import { render, staticRenderFns } from "./CounselorAI.vue?vue&type=template&id=6772844a"
import script from "./CounselorAI.vue?vue&type=script&lang=js"
export * from "./CounselorAI.vue?vue&type=script&lang=js"
import style0 from "./CounselorAI.vue?vue&type=style&index=0&id=6772844a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports